export default __webpack_public_path__ + "static/media/Walk (7).b5d30362.png";